export function esFuncion(value) {
   return typeof value === 'function';
}
/**
 *
 * @param {string} msg mensaje de error
 * @param {*} dataAuxiliar data auxiliar informativa sobre el error
 * @returns {{existeError:boolean, msg:string, data:*}} Objeto que describe si existe error su mensaje correspondiente y la data auxiliar agregada.
 */
export function generarObjetoError(msg, dataAuxiliar = {}) {
   return {
      existeError: msg !== '',
      msg,
      data: dataAuxiliar
   };
}

/**
 * Retorna el mismo objeto `longitud` o un objeto con su misma forma retornado por la funcion `opciones.fnLongitudCondicional`
 * @param {Object} longitud Descripcion de la longitud de un valor
 * @param {number} longitud.long Longitud exacta de la cadena que representa el valor a validar, si esta presente se ignora `max` y `min`
 * @param {number} longitud.max Maxima longitud de la cadena que representa el valor a validar
 * @param {number} longitud.min Maxima longitud de la cadena que representa el valor a validar
 * @param {Object} opciones Opciones de la funcion
 * @param {Function} opciones.fnLongitudCondicional Function que retorna un objeto con la misma forma de `longitud` con valores dependientes de los parametros definidos en `opciones.parametrosFn`
 * @param {{}|[]} opciones.parametrosFn Variables enviadas como primer parametro a la funcion `opciones.fnLongitudCondicional` para definir el nuevo objeto longitud
 * @returns {{long:number,max:number,min:number}} Objeto con la misma estructura que `longitud`
 */
export function getLongitud(longitud = null, {fnLongitudCondicional, parametrosFn = null} = {}) {
   if (fnLongitudCondicional && esFuncion(fnLongitudCondicional)) {
      return fnLongitudCondicional(parametrosFn);
   }
   return longitud;
}
/**
 *
 * @param {string} value
 * @param {*} longitud
 * @param {*} parametrosFn
 * @returns
 */
export function validarLongitud(value, longitud, parametrosFn = null) {
   const longitudEncontrada = getLongitud(longitud, {
      fnLongitudCondicional: longitud,
      parametrosFn: parametrosFn
   });
   const {long, max, min} = longitudEncontrada;
   if (long && long > 0 && value.length !== long) {
      return generarObjetoError(`debe tener exactamente ${long} caracteres`, {
         __longitud__: longitudEncontrada
      });
   }
   let errLongitud = false;
   let errMsg = '';
   if (min > 0 && value.length < min) {
      errMsg = `debe tener como minimo ${min} caracteres`;
      errLongitud = true;
   }
   if (max > 0 && value.length > max) {
      errMsg = `debe tener como maximo ${max} caracteres`;
      errLongitud = true;
   }
   if (errLongitud && max > 0 && min > 0) {
      return generarObjetoError(
         `debe tener como minimo ${min} caracteres y como maximo ${max} caracteres`,
         {
            __longitud__: longitudEncontrada
         }
      );
   }
   return generarObjetoError(errMsg, {
      __longitud__: longitudEncontrada
   });
}
